{
  "about.blocks": "Servidors moderats",
  "about.contact": "Contacte :",
  "about.default_locale": "Per defaut",
  "about.disclaimer": "Mastodon es gratuit, un logicial libre e una marca de Mastodon gGmbH.",
  "about.domain_blocks.no_reason_available": "Rason pas disponibla",
  "about.domain_blocks.silenced.title": "Limitats",
  "about.domain_blocks.suspended.title": "Suspenduts",
  "about.language_label": "Lenga",
  "about.not_available": "Aquesta informacion foguèt pas renduda disponibla sus aqueste servidor.",
  "about.powered_by": "Malhum social descentralizat propulsat per {mastodon}",
  "about.rules": "Règlas del servidor",
  "account.account_note_header": "Nòta personala",
  "account.activity": "Activitat",
  "account.add_note": "Apondre una nòta personala",
  "account.add_or_remove_from_list": "Ajustar o tirar de las listas",
  "account.badges.bot": "Robòt",
  "account.badges.group": "Grop",
  "account.block": "Blocar @{name}",
  "account.block_domain": "Tot amagar del domeni {domain}",
  "account.block_short": "Blocar",
  "account.blocked": "Blocat",
  "account.cancel_follow_request": "Retirar la demanda d’abonament",
  "account.copy": "Copiar lo ligam del perfil",
  "account.direct": "Mencionar @{name} en privat",
  "account.disable_notifications": "Quitar de m’avisar quand @{name} publica quicòm",
  "account.edit_profile": "Modificar lo perfil",
  "account.edit_profile_short": "Modificar",
  "account.enable_notifications": "M’avisar quand @{name} publica quicòm",
  "account.endorse": "Mostrar pel perfil",
  "account.familiar_followers_many": "Seguit per {name1}, {name2} e {othersCount, plural, one {qualqu’un mai que coneissètz} other {# autras personas que coneissètz}}",
  "account.familiar_followers_one": "Seguit per {name1}",
  "account.familiar_followers_two": "Seguit per {name1} e {name2}",
  "account.featured.accounts": "Perfils",
  "account.follow": "Sègre",
  "account.follow_back": "Sègre en retorn",
  "account.follow_request_cancel": "Anullar la demanda",
  "account.follow_request_cancel_short": "Anullar",
  "account.followers": "Seguidors",
  "account.followers.empty": "Degun sèc pas aqueste utilizaire pel moment.",
  "account.following": "Abonat",
  "account.follows.empty": "Aqueste utilizaire sèc pas degun pel moment.",
  "account.go_to_profile": "Anar al perfil",
  "account.hide_reblogs": "Rescondre los partatges de @{name}",
  "account.in_memoriam": "En Memòria.",
  "account.joined_short": "Venguèt lo",
  "account.languages": "Modificar las lengas seguidas",
  "account.link_verified_on": "La proprietat d’aqueste ligam foguèt verificada lo {date}",
  "account.locked_info": "L’estatut de privacitat del compte es configurat sus clavat. Lo proprietari causís qual pòt sègre son compte.",
  "account.media": "Mèdias",
  "account.mention": "Mencionar @{name}",
  "account.menu.mention": "Mencionar",
  "account.menu.mute": "Silenciar lo compte",
  "account.menu.note.description": "Sonque visibla per vos",
  "account.menu.remove_follower": "Tirar lo seguidor",
  "account.menu.report": "Senhalar lo compte",
  "account.menu.share": "Partejar…",
  "account.moved_to": "{name} indiquèt que son nòu compte es ara :",
  "account.mute": "Rescondre @{name}",
  "account.mute_notifications_short": "Amudir las notificacions",
  "account.mute_short": "Amudir",
  "account.muted": "Mes en silenci",
  "account.mutual": "Vos seguissètz",
  "account.no_bio": "Cap de descripcion pas fornida.",
  "account.node_modal.field_label": "Nòta personala",
  "account.node_modal.save": "Enregistrar",
  "account.node_modal.title": "Apondre una nòta personala",
  "account.note.edit_button": "Modificar",
  "account.open_original_page": "Dobrir la pagina d’origina",
  "account.posts": "Tuts",
  "account.remove_from_followers": "Tirar {name} dels seguidors",
  "account.report": "Senhalar @{name}",
  "account.requested_follow": "{name} a demandat a vos sègre",
  "account.share": "Partejar lo perfil a @{name}",
  "account.show_reblogs": "Mostrar los partatges de @{name}",
  "account.timeline.pinned": "Penjat",
  "account.unblock": "Desblocar @{name}",
  "account.unblock_domain": "Desblocar {domain}",
  "account.unblock_domain_short": "Desblocar",
  "account.unblock_short": "Desblocat",
  "account.unendorse": "Mostrar pas pel perfil",
  "account.unfollow": "Quitar de sègre",
  "account.unmute": "Quitar de rescondre @{name}",
  "account.unmute_notifications_short": "Restablir las notificacions",
  "account.unmute_short": "Tornar afichar",
  "account_edit.column_title": "Modificar lo perfil",
  "account_edit.field_delete_modal.delete_button": "Suprimir",
  "account_edit.field_edit_modal.value_label": "Valor",
  "account_note.placeholder": "Clicar per ajustar una nòta",
  "admin.dashboard.retention.average": "Mejana",
  "admin.dashboard.retention.cohort": "Mes d’inscripcion",
  "admin.dashboard.retention.cohort_size": "Utilizaires novèls",
  "alert.rate_limited.message": "Mercés de tornar ensajar aprèp {retry_time, time, medium}.",
  "alert.rate_limited.title": "Taus limitat",
  "alert.unexpected.message": "Una error s’es producha.",
  "alert.unexpected.title": "Ops !",
  "alt_text_badge.title": "Tèxt alternatiu",
  "alt_text_modal.add_alt_text": "Inserir tèxte alteratiu",
  "alt_text_modal.add_text_from_image": "Apondre tèxte de l’imatge",
  "alt_text_modal.cancel": "Anullar",
  "alt_text_modal.change_thumbnail": "Cambiar de miniatura",
  "alt_text_modal.done": "Acabat",
  "announcement.announcement": "Anóncia",
  "annual_report.summary.close": "Tampar",
  "annual_report.summary.copy_link": "Copiar lo ligam",
  "attachments_list.unprocessed": "(pas tractat)",
  "audio.hide": "Amagar àudio",
  "block_modal.show_less": "Ne veire mens",
  "block_modal.show_more": "Ne veire mai",
  "boost_modal.combo": "Podètz botar {combo} per passar aquò lo còp que ven",
  "bundle_column_error.copy_stacktrace": "Copiar senhalament d’avaria",
  "bundle_column_error.error.title": "Oh non !",
  "bundle_column_error.network.title": "Error de ret",
  "bundle_column_error.retry": "Tornar ensajar",
  "bundle_column_error.return": "Tornar a l’acuèlh",
  "bundle_column_error.routing.title": "404",
  "bundle_modal_error.close": "Tampar",
  "bundle_modal_error.retry": "Tornar ensajar",
  "closed_registrations_modal.find_another_server": "Trobar un autre servidor",
  "closed_registrations_modal.title": "S’inscriure a Mastodon",
  "collections.visibility_public": "Publica",
  "collections.visibility_title": "Visibilitat",
  "collections.visibility_unlisted": "Non listada",
  "column.about": "A prepaus",
  "column.blocks": "Personas blocadas",
  "column.bookmarks": "Marcadors",
  "column.community": "Flux public local",
  "column.create_list": "Crear una lista",
  "column.direct": "Mencions privadas",
  "column.directory": "Percórrer los perfils",
  "column.domain_blocks": "Domenis resconduts",
  "column.edit_list": "Modificar la lista",
  "column.favourites": "Favorits",
  "column.firehose": "Tuts en dirèct",
  "column.firehose_local": "Fial en dirècte d’aqueste servidor",
  "column.firehose_singular": "Fial en dirècte",
  "column.follow_requests": "Demandas d’abonament",
  "column.home": "Acuèlh",
  "column.list_members": "Gestion dels membres de la lista",
  "column.lists": "Listas",
  "column.mutes": "Personas rescondudas",
  "column.notifications": "Notificacions",
  "column.pins": "Tuts penjats",
  "column.public": "Flux public global",
  "column_back_button.label": "Tornar",
  "column_header.hide_settings": "Amagar los paramètres",
  "column_header.moveLeft_settings": "Desplaçar la colomna a man drecha",
  "column_header.moveRight_settings": "Desplaçar la colomna a man esquèrra",
  "column_header.pin": "Penjar",
  "column_header.show_settings": "Mostrar los paramètres",
  "column_header.unpin": "Despenjar",
  "column_search.cancel": "Anullar",
  "community.column_settings.local_only": "Sonque local",
  "community.column_settings.media_only": "Solament los mèdias",
  "community.column_settings.remote_only": "Sonque alonhat",
  "compose.language.change": "Cambiar de lenga",
  "compose.language.search": "Recercar de lengas...",
  "compose.published.body": "Tut publicat.",
  "compose.published.open": "Dobrir",
  "compose.saved.body": "Publicacion enregistrada.",
  "compose_form.direct_message_warning_learn_more": "Ne saber mai",
  "compose_form.encryption_warning": "Las publicacions sus Mastodon son pas chifradas del cap a la fin. Partegetz pas d’informacions sensiblas sus Mastodon.",
  "compose_form.hashtag_warning": "This post won't be listed under any hashtag as it is unlisted. Only public posts can be searched by hashtag.",
  "compose_form.lock_disclaimer": "Vòstre compte es pas {locked}. Tot lo mond pòt vos sègre e veire los estatuts reservats als seguidors.",
  "compose_form.lock_disclaimer.lock": "clavat",
  "compose_form.placeholder": "A de qué pensatz ?",
  "compose_form.poll.duration": "Durada del sondatge",
  "compose_form.poll.switch_to_multiple": "Cambiar lo sondatge per permetre de causidas multiplas",
  "compose_form.poll.switch_to_single": "Cambiar lo sondatge per permetre una sola causida",
  "compose_form.poll.type": "Estil",
  "compose_form.publish": "Publicar",
  "compose_form.reply": "Respondre",
  "compose_form.save_changes": "Actualizar",
  "compose_form.spoiler.marked": "Lo tèxte es rescondut jos l’avertiment",
  "compose_form.spoiler.unmarked": "Lo tèxte es pas rescondut",
  "compose_form.spoiler_placeholder": "Avertiment de contengut (opcional)",
  "confirmation_modal.cancel": "Anullar",
  "confirmations.block.confirm": "Blocar",
  "confirmations.delete.confirm": "Escafar",
  "confirmations.delete.message": "Volètz vertadièrament escafar l’estatut ?",
  "confirmations.delete.title": "Suprimir la publicacion ?",
  "confirmations.delete_list.confirm": "Suprimir",
  "confirmations.delete_list.message": "Volètz vertadièrament suprimir aquesta lista per totjorn ?",
  "confirmations.delete_list.title": "Suprimir la lista ?",
  "confirmations.discard_edit_media.confirm": "Ignorar",
  "confirmations.logout.confirm": "Desconnexion",
  "confirmations.logout.message": "Volètz vertadièrament vos desconnectar ?",
  "confirmations.missing_alt_text.confirm": "Apondre un tèxte alternatiu",
  "confirmations.missing_alt_text.message": "Vòstra publicacion conten un mèdia sens tèxt alternatiu. L'apondon de descripcions ajuda a rendre vòstre contengut accessible a mai de monde.",
  "confirmations.missing_alt_text.secondary": "Publicar malgrat tot",
  "confirmations.missing_alt_text.title": "Apondre un tèxte alternatiu ?",
  "confirmations.mute.confirm": "Rescondre",
  "confirmations.quiet_post_quote_info.dismiss": "Me remembrar pas mai",
  "confirmations.quiet_post_quote_info.got_it": "Plan comprés",
  "confirmations.redraft.confirm": "Escafar & tornar formular",
  "confirmations.revoke_quote.title": "Suprimir la publicacion ?",
  "confirmations.unblock.confirm": "Desblocar",
  "confirmations.unblock.title": "Desblocar {name} ?",
  "confirmations.unfollow.confirm": "Quitar de sègre",
  "confirmations.unfollow.title": "Quitar de sègre {name} ?",
  "content_warning.hide": "Amagar la publicacion",
  "content_warning.show_more": "Ne veire mai",
  "conversation.delete": "Suprimir la conversacion",
  "conversation.mark_as_read": "Marcar coma legida",
  "conversation.open": "Veire la conversacion",
  "conversation.with": "Amb {names}",
  "copy_icon_button.copied": "Copiat al quichapapièr",
  "copypaste.copied": "Copiat",
  "copypaste.copy_to_clipboard": "Copiar al quichapapièr",
  "directory.federated": "Del fediverse conegut",
  "directory.local": "Solament de {domain}",
  "directory.new_arrivals": "Nòus-venguts",
  "directory.recently_active": "Actius fa res",
  "disabled_account_banner.account_settings": "Paramètres de compte",
  "disabled_account_banner.text": "Vòstre compte {disabledAccount} es actualament desactivat.",
  "dismissable_banner.community_timeline": "Vaquí las publicacions mai recentas del monde amb un compte albergat per {domain}.",
  "dismissable_banner.dismiss": "Ignorar",
  "embed.instructions": "Embarcar aqueste estatut per lo far veire sus un site Internet en copiar lo còdi çai-jos.",
  "embed.preview": "Semblarà aquò :",
  "emoji_button.activity": "Activitats",
  "emoji_button.clear": "Escafar",
  "emoji_button.custom": "Personalizats",
  "emoji_button.flags": "Drapèus",
  "emoji_button.food": "Beure e manjar",
  "emoji_button.label": "Inserir un emoji",
  "emoji_button.nature": "Natura",
  "emoji_button.not_found": "Cap d’emoji ! (╯°□°）╯︵ ┻━┻",
  "emoji_button.objects": "Objèctes",
  "emoji_button.people": "Gents",
  "emoji_button.recent": "Sovent utilizats",
  "emoji_button.search": "Cercar…",
  "emoji_button.search_results": "Resultats de recèrca",
  "emoji_button.symbols": "Simbòls",
  "emoji_button.travel": "Viatges & lòcs",
  "empty_column.account_suspended": "Compte suspendut",
  "empty_column.account_timeline": "Cap de tuts aquí !",
  "empty_column.account_unavailable": "Perfil pas disponible",
  "empty_column.blocks": "Avètz pas blocat degun pel moment.",
  "empty_column.bookmarked_statuses": "Avètz pas cap de tuts marcats pel moment. Quand ne marquetz un, serà mostrat aquí.",
  "empty_column.community": "Lo flux public local es void. Escrivètz quicòm per lo garnir !",
  "empty_column.domain_blocks": "I a pas encara cap de domeni amagat.",
  "empty_column.explore_statuses": "I a pas res en tendéncia pel moment. Tornatz mai tard !",
  "empty_column.follow_requests": "Avètz pas encara de demanda d’abonament. Quand n’auretz una apareisserà aquí.",
  "empty_column.hashtag": "I a pas encara de contengut ligat a aquesta etiqueta.",
  "empty_column.home": "Vòstre flux d’acuèlh es void. Visitatz {public} o utilizatz la recèrca per vos connectar a d’autras personas.",
  "empty_column.list": "I a pas res dins la lista pel moment. Quand de membres d’aquesta lista publiquen de novèls estatuts los veiretz aquí.",
  "empty_column.mutes": "Encara avètz pas mes en silenci degun.",
  "empty_column.notifications": "Avètz pas encara de notificacions. Respondètz a qualqu’un per començar una conversacion.",
  "empty_column.public": "I a pas res aquí ! Escrivètz quicòm de public, o seguètz de personas d’autres servidors per garnir lo flux public",
  "error.unexpected_crash.explanation": "A causa d’una avaria dins nòstre còdi o d’un problèma de compatibilitat de navegador, aquesta pagina se pòt pas afichar corrèctament.",
  "error.unexpected_crash.explanation_addons": "Aquesta pagina podiá pas s’afichar corrèctament. Aquesta error arriba sovent a causa d’un modul complementari de navigador o una aisina de traduccion automatica.",
  "error.unexpected_crash.next_steps": "Ensajatz d’actualizar la pagina. S’aquò càmbia pas res, podètz provar d’utilizar Mastodon via un navegador diferent o d’una aplicacion nativa estant.",
  "error.unexpected_crash.next_steps_addons": "Ensajatz de los desactivar o actualizatz la pagina. Se aquò ajuda pas, podètz ensajar d’utilizar Mastodon via un autre navigador o una aplicacion nativa.",
  "errors.unexpected_crash.copy_stacktrace": "Copiar las traças al quichapapièrs",
  "errors.unexpected_crash.report_issue": "Senhalar un problèma",
  "explore.suggested_follows": "Personas",
  "explore.title": "Tendéncia",
  "explore.trending_links": "Novèlas",
  "explore.trending_statuses": "Publicacions",
  "explore.trending_tags": "Etiquetas",
  "filter_modal.added.expired_title": "Filtre expirat !",
  "filter_modal.added.review_and_configure_title": "Paramètres del filtre",
  "filter_modal.added.settings_link": "page de parametratge",
  "filter_modal.added.title": "Filtre apondut !",
  "filter_modal.select_filter.context_mismatch": "s’aplica pas a aqueste contèxte",
  "filter_modal.select_filter.expired": "expirat",
  "filter_modal.select_filter.prompt_new": "Categoria novèla : {name}",
  "filter_modal.select_filter.search": "Cercar o crear",
  "filter_modal.select_filter.title": "Filtrar aquesta publicacion",
  "filter_modal.title.status": "Filtrar una publicacion",
  "firehose.local": "Aqueste servidor",
  "follow_request.authorize": "Acceptar",
  "follow_request.reject": "Regetar",
  "follow_requests.unlocked_explanation": "Encara que vòstre compte siasque pas verrolhat, la còla de {domain} pensèt que volriatz benlèu repassar las demandas d’abonament d’aquestes comptes.",
  "followed_tags": "Etiquetas seguidas",
  "footer.about": "A prepaus",
  "footer.directory": "Annuari de perfils",
  "footer.get_app": "Obténer l’aplicacion",
  "footer.keyboard_shortcuts": "Acorchis clavièr",
  "footer.privacy_policy": "Politica de confidencialitat",
  "footer.source_code": "Veire lo còdi font",
  "footer.status": "Estat",
  "footer.terms_of_service": "Condicions d’utilizacion",
  "generic.saved": "Enregistrat",
  "getting_started.heading": "Per començar",
  "hashtag.column_header.tag_mode.all": "e {additional}",
  "hashtag.column_header.tag_mode.any": "o {additional}",
  "hashtag.column_header.tag_mode.none": "sens {additional}",
  "hashtag.column_settings.select.no_options_message": "Cap de suggestion pas trobada",
  "hashtag.column_settings.select.placeholder": "Picatz d’etiquetas…",
  "hashtag.column_settings.tag_mode.all": "Totes aquestes",
  "hashtag.column_settings.tag_mode.any": "Un d’aquestes",
  "hashtag.column_settings.tag_mode.none": "Cap d’aquestes",
  "hashtag.column_settings.tag_toggle": "Inclure las etiquetas suplementàrias dins aquesta colomna",
  "hashtag.counter_by_accounts": "{count, plural, one {{counter} participant} other {{counter} participants}}",
  "hashtag.counter_by_uses": "{count, plural, one {{counter} tut} other {{counter} tuts}}",
  "hashtag.counter_by_uses_today": "{count, plural, one {{counter} tut} other {{counter} tuts}} uèi",
  "hashtag.follow": "Sègre l’etiqueta",
  "hashtag.mute": "Amudar #{hashtag}",
  "hashtag.unfollow": "Quitar de sègre l’etiqueta",
  "hashtags.and_other": "…e {count, plural, one {}other {# de mai}}",
  "home.column_settings.show_reblogs": "Mostrar los partatges",
  "home.column_settings.show_replies": "Mostrar las responsas",
  "home.hide_announcements": "Rescondre las anóncias",
  "home.pending_critical_update.link": "Veire las mesas a jorn",
  "home.show_announcements": "Mostrar las anóncias",
  "info_button.label": "Ajuda",
  "interaction_modal.on_another_server": "Sus un autre servidor",
  "interaction_modal.on_this_server": "Sus aqueste servidor",
  "intervals.full.days": "{number, plural, one {# jorn} other {# jorns}}",
  "intervals.full.hours": "{number, plural, one {# ora} other {# oras}}",
  "intervals.full.minutes": "{number, plural, one {# minuta} other {# minutas}}",
  "keyboard_shortcuts.back": "anar enrèire",
  "keyboard_shortcuts.blocked": "dobrir la lista d’utilizaires blocats",
  "keyboard_shortcuts.boost": "partejar",
  "keyboard_shortcuts.column": "centrar un estatut a una colomna",
  "keyboard_shortcuts.compose": "anar al camp tèxte",
  "keyboard_shortcuts.description": "descripcion",
  "keyboard_shortcuts.down": "far davalar dins la lista",
  "keyboard_shortcuts.enter": "dobrir los estatuts",
  "keyboard_shortcuts.favourite": "Marcar coma favorit",
  "keyboard_shortcuts.favourites": "Dobrir la lista dels favorits",
  "keyboard_shortcuts.federated": "dobrir lo flux public global",
  "keyboard_shortcuts.heading": "Acorchis clavièr",
  "keyboard_shortcuts.home": "dobrir lo flux public local",
  "keyboard_shortcuts.hotkey": "Acorchis",
  "keyboard_shortcuts.legend": "mostrar aquesta legenda",
  "keyboard_shortcuts.local": "dobrir lo flux public local",
  "keyboard_shortcuts.mention": "mencionar l’autor",
  "keyboard_shortcuts.muted": "dobrir la lista dels utilizaires silenciats",
  "keyboard_shortcuts.my_profile": "dobrir vòstre perfil",
  "keyboard_shortcuts.notifications": "dobrir la colomna de notificacions",
  "keyboard_shortcuts.open_media": "dobrir lo mèdia",
  "keyboard_shortcuts.pinned": "dobrir la lista dels tuts penjats",
  "keyboard_shortcuts.profile": "dobrir lo perfil de l’autor",
  "keyboard_shortcuts.reply": "respondre",
  "keyboard_shortcuts.requests": "dorbir la lista de demanda d’abonament",
  "keyboard_shortcuts.search": "anar a la recèrca",
  "keyboard_shortcuts.spoilers": "per mostrar/rescondre lo camp CW",
  "keyboard_shortcuts.start": "dobrir la colomna « Per començar »",
  "keyboard_shortcuts.toggle_hidden": "mostrar/amagar lo tèxte dels avertiments",
  "keyboard_shortcuts.toggle_sensitivity": "mostrar/rescondre los mèdias",
  "keyboard_shortcuts.toot": "començar un estatut tot novèl",
  "keyboard_shortcuts.unfocus": "quitar lo camp tèxte/de recèrca",
  "keyboard_shortcuts.up": "far montar dins la lista",
  "learn_more_link.got_it": "Plan comprés",
  "learn_more_link.learn_more": "Ne saber mai",
  "lightbox.close": "Tampar",
  "lightbox.next": "Seguent",
  "lightbox.previous": "Precedent",
  "limited_account_hint.action": "Afichar lo perfil de tota manièra",
  "limited_account_hint.title": "Aqueste perfil foguèt rescondut per la moderacion de {domain}.",
  "link_preview.author": "Per {name}",
  "link_preview.more_from_author": "Mai de {name}",
  "lists.delete": "Suprimir la lista",
  "lists.edit": "Modificar la lista",
  "lists.replies_policy.followed": "Quin seguidor que siá",
  "lists.replies_policy.list": "Membres de la lista",
  "lists.replies_policy.none": "Degun",
  "lists.save": "Enregistrar",
  "lists.search": "Recercar",
  "load_pending": "{count, plural, one {# nòu element} other {# nòu elements}}",
  "loading_indicator.label": "Cargament…",
  "media_gallery.hide": "Rescondre",
  "navigation_bar.about": "A prepaus",
  "navigation_bar.administration": "Administracion",
  "navigation_bar.advanced_interface": "Dobrir l’interfàcia web avançada",
  "navigation_bar.automated_deletion": "Supression auto de las publicacions",
  "navigation_bar.blocks": "Personas blocadas",
  "navigation_bar.bookmarks": "Marcadors",
  "navigation_bar.direct": "Mencions privadas",
  "navigation_bar.domain_blocks": "Domenis resconduts",
  "navigation_bar.favourites": "Favorits",
  "navigation_bar.filters": "Mots ignorats",
  "navigation_bar.follow_requests": "Demandas d’abonament",
  "navigation_bar.followed_tags": "Etiquetas seguidas",
  "navigation_bar.follows_and_followers": "Abonament e seguidors",
  "navigation_bar.import_export": "Import e export",
  "navigation_bar.lists": "Listas",
  "navigation_bar.logout": "Desconnexion",
  "navigation_bar.moderation": "Moderacion",
  "navigation_bar.more": "Mai",
  "navigation_bar.mutes": "Personas rescondudas",
  "navigation_bar.preferences": "Preferéncias",
  "navigation_bar.search": "Recercar",
  "navigation_bar.search_trends": "Recèrca / Tendéncia",
  "not_signed_in_indicator.not_signed_in": "Devètz vos connectar per accedir a aquesta ressorsa.",
  "notification.admin.report": "{name} senhalèt {target}",
  "notification.admin.sign_up": "{name} se marquèt",
  "notification.favourite": "{name} a mes vòstre estatut en favorit",
  "notification.follow": "{name} vos sèc",
  "notification.follow_request": "{name} a demandat a vos sègre",
  "notification.label.mention": "Mencion",
  "notification.label.private_mention": "Mencion privada",
  "notification.label.private_reply": "Responsa privada",
  "notification.label.quote": "{name} a citat vòstra publicacion",
  "notification.label.reply": "Respondre",
  "notification.mention": "Mencionar",
  "notification.mentioned_you": "{name} vos a mencionat",
  "notification.moderation-warning.learn_more": "Ne saber mai",
  "notification.own_poll": "Vòstre sondatge es acabat",
  "notification.reblog": "{name} a partejat vòstre estatut",
  "notification.relationships_severance_event.learn_more": "Ne saber mai",
  "notification.status": "{name} ven de publicar",
  "notification.update": "{name} modifiquèt sa publicacion",
  "notifications.clear": "Escafar",
  "notifications.clear_confirmation": "Volètz vertadièrament escafar totas vòstras las notificacions ?",
  "notifications.column_settings.admin.report": "Senhalaments novèls :",
  "notifications.column_settings.admin.sign_up": "Nòus inscrits :",
  "notifications.column_settings.alert": "Notificacions localas",
  "notifications.column_settings.favourite": "Favorits :",
  "notifications.column_settings.follow": "Nòus seguidors :",
  "notifications.column_settings.follow_request": "Novèla demanda d’abonament :",
  "notifications.column_settings.mention": "Mencions :",
  "notifications.column_settings.poll": "Resultats del sondatge :",
  "notifications.column_settings.push": "Notificacions",
  "notifications.column_settings.reblog": "Partatges :",
  "notifications.column_settings.show": "Mostrar dins la colomna",
  "notifications.column_settings.sound": "Emetre un son",
  "notifications.column_settings.status": "Tuts novèls :",
  "notifications.column_settings.unread_notifications.category": "Notificacions pas legidas",
  "notifications.column_settings.unread_notifications.highlight": "Forçar sus las notificacions pas legidas",
  "notifications.column_settings.update": "Modificacions :",
  "notifications.filter.all": "Totas",
  "notifications.filter.boosts": "Partages",
  "notifications.filter.favourites": "Favorits",
  "notifications.filter.follows": "Seguiments",
  "notifications.filter.mentions": "Mencions",
  "notifications.filter.polls": "Resultats del sondatge",
  "notifications.filter.statuses": "Mesas a jorn del monde que seguissètz",
  "notifications.grant_permission": "Acordar l’autorizacion.",
  "notifications.group": "{count} notificacions",
  "notifications.mark_as_read": "Marcar totas las notificacions coma legidas",
  "notifications.permission_denied": "Las notificacion burèu son pas disponiblas a causa del refús de las demandas d’autorizacion navigador",
  "notifications.permission_denied_alert": "Las notificacions burèu son pas activada, per çò que las autorizacions son estadas refusada abans",
  "notifications.permission_required": "Las notificacions de burèu son pas indisponiblas perque las permissions requeridas son pas estadas acordadas.",
  "notifications_permission_banner.enable": "Activar las notificacions burèu",
  "notifications_permission_banner.how_to_control": "Per recebre las notificacions de Mastodon quand es pas dobèrt, activatz las notificacions de burèu. Podètz precisar quin tipe de notificacion generarà una notificacion de burèu via lo boton {icon} dessús un còp activadas.",
  "notifications_permission_banner.title": "Manquetz pas jamai res",
  "onboarding.profile.display_name": "Nom d’afichatge",
  "onboarding.profile.note": "Biografia",
  "picture_in_picture.restore": "Lo tornar",
  "poll.closed": "Tampat",
  "poll.refresh": "Actualizar",
  "poll.reveal": "Veire los resultats",
  "poll.total_people": "{count, plural, one {# persona} other {# personas}}",
  "poll.total_votes": "{count, plural, one {# vòte} other {# vòtes}}",
  "poll.vote": "Votar",
  "poll.voted": "Avètz votat per aquesta responsa",
  "poll.votes": "{votes, plural, one {# vòte} other {# vòtes}}",
  "poll_button.add_poll": "Ajustar un sondatge",
  "poll_button.remove_poll": "Levar lo sondatge",
  "privacy.change": "Ajustar la confidencialitat del messatge",
  "privacy.direct.long": "Sonque los qu’avètz mencionats dins la publicacion",
  "privacy.direct.short": "Mencion privada",
  "privacy.private.long": "Mostrar pas qu’als seguidors",
  "privacy.private.short": "Seguidors",
  "privacy.public.long": "Tot lo monde de e defòra de Mastodon",
  "privacy.public.short": "Public",
  "privacy.unlisted.long": "Rescondut dels resultats de recèrca de Mastodon, las tendéncias e las cronologias publicas",
  "privacy.unlisted.short": "Public silenciós",
  "privacy_policy.last_updated": "Darrièra actualizacion {date}",
  "privacy_policy.title": "Politica de confidencialitat",
  "refresh": "Actualizar",
  "relative_time.days": "fa {number}d",
  "relative_time.full.days": "{number, plural, one {# jorn} other {# jorns}} ago",
  "relative_time.full.hours": "fa {number, plural, one {# ora} other {# oras}}",
  "relative_time.full.just_now": "ara",
  "relative_time.full.minutes": "fa {number, plural, one {# minuta} other {# minutas}}",
  "relative_time.full.seconds": "fa {number, plural, one {# segonda} other {# segondas}}",
  "relative_time.hours": "fa {number}h",
  "relative_time.just_now": "ara",
  "relative_time.minutes": "fa {number} min",
  "relative_time.seconds": "fa {number}s",
  "relative_time.today": "uèi",
  "reply_indicator.cancel": "Anullar",
  "reply_indicator.poll": "Sondatge",
  "report.block": "Blocar",
  "report.categories.other": "Autre",
  "report.categories.spam": "Messatge indesirable",
  "report.category.subtitle": "Causissètz çò que correspond mai",
  "report.category.title_account": "perfil",
  "report.category.title_status": "publicacion",
  "report.close": "Acabat",
  "report.forward": "Far sègre a {target}",
  "report.forward_hint": "Lo compte ven d’un autre servidor. Volètz mandar una còpia anonima del rapòrt enlai tanben ?",
  "report.mute": "Amudir",
  "report.next": "Seguent",
  "report.placeholder": "Comentaris addicionals",
  "report.reasons.dislike": "M’agrada pas",
  "report.reasons.dislike_description": "Es pas quicòm que volriatz veire",
  "report.reasons.other": "Es quicòm mai",
  "report.reasons.other_description": "Lo problèma es pas dins cap d’autra categoria",
  "report.reasons.spam": "Es un messatge indesirable",
  "report.reasons.spam_description": "Ligams enganaires, fals engatjament o responsas repetitivas",
  "report.reasons.violation": "Viòla las règlas del servidor",
  "report.rules.subtitle": "Causissètz çò que s’aplica",
  "report.rules.title": "Qualas règlas foguèron enfrachas ?",
  "report.statuses.subtitle": "Seleccionatz çò que s’aplica",
  "report.statuses.title": "I a de publicacions per apiejar aqueste senhalament ?",
  "report.submit": "Mandar",
  "report.target": "Senhalar {target}",
  "report.thanks.title": "Volètz pas veire aquò ?",
  "report.unfollow": "Quitar de sègre {name}",
  "report.unfollow_explanation": "Seguissètz aqueste compte. Per veire pas pus lors publicacions dins vòstra cronologia, quitatz de lo sègre.",
  "report_notification.attached_statuses": "{count, plural, one {{count} publicacion junta} other {{count} publicacions juntas}}",
  "report_notification.categories.other": "Autre",
  "report_notification.categories.spam": "Messatge indesirable",
  "report_notification.categories.violation": "Violacion de las règlas",
  "report_notification.open": "Dobrir lo senhalament",
  "search.no_recent_searches": "Cap de recèrcas recentas",
  "search.placeholder": "Recercar",
  "search.search_or_paste": "Recercar o picar una URL",
  "search_popout.language_code": "Còdi ISO de lenga",
  "search_popout.options": "Opcions de recèrca",
  "search_popout.quick_actions": "Accions rapidas",
  "search_popout.recent": "Recèrcas recentas",
  "search_popout.specific_date": "data especifica",
  "search_popout.user": "utilizaire",
  "search_results.accounts": "Perfils",
  "search_results.all": "Tot",
  "search_results.hashtags": "Etiquetas",
  "search_results.see_all": "O veire tot",
  "search_results.statuses": "Tuts",
  "server_banner.active_users": "utilizaires actius",
  "server_banner.administered_by": "Administrat per :",
  "server_banner.server_stats": "Estatisticas del servidor :",
  "sign_in_banner.create_account": "Crear un compte",
  "sign_in_banner.sign_in": "Se connectar",
  "status.admin_account": "Dobrir l’interfàcia de moderacion per @{name}",
  "status.admin_domain": "Dobrir l’interfàcia de moderacion per {domain}",
  "status.admin_status": "Dobrir aqueste estatut dins l’interfàcia de moderacion",
  "status.block": "Blocar @{name}",
  "status.bookmark": "Marcador",
  "status.cancel_reblog_private": "Quitar de partejar",
  "status.cannot_reblog": "Aqueste estatut pòt pas èsser partejat",
  "status.context.loading": "Cargament de mai de responsas",
  "status.context.more_replies_found": "Mai de responsas trobadas",
  "status.continued_thread": "Seguida del fial",
  "status.copy": "Copiar lo ligam de l’estatut",
  "status.delete": "Escafar",
  "status.detailed_status": "Vista detalhada de la convèrsa",
  "status.direct": "Mencionar @{name} en privat",
  "status.direct_indicator": "Mencion privada",
  "status.edit": "Modificar",
  "status.edited_x_times": "Modificat {count, plural, un {{count} còp} other {{count} còps}}",
  "status.favourite": "Apondre als favorits",
  "status.filter": "Filtrar aquesta publicacion",
  "status.history.created": "{name} o creèt lo {date}",
  "status.history.edited": "{name} o modifiquèt lo {date}",
  "status.load_more": "Cargar mai",
  "status.media.open": "Clicar per dobrir",
  "status.media.show": "Clicar per mostar",
  "status.media_hidden": "Mèdia rescondut",
  "status.mention": "Mencionar",
  "status.more": "Mai",
  "status.mute": "Rescondre @{name}",
  "status.mute_conversation": "Rescondre la conversacion",
  "status.open": "Desplegar aqueste estatut",
  "status.pin": "Penjar al perfil",
  "status.read_more": "Ne legir mai",
  "status.reblog": "Partejar",
  "status.reblogged_by": "{name} a partejat",
  "status.reblogs.empty": "Degun a pas encara partejat aqueste tut. Quand qualqu’un o farà, apareisserà aquí.",
  "status.redraft": "Escafar e tornar formular",
  "status.remove_bookmark": "Suprimir lo marcador",
  "status.replied_to": "Respondut a {name}",
  "status.reply": "Respondre",
  "status.replyAll": "Respondre a la conversacion",
  "status.report": "Senhalar @{name}",
  "status.sensitive_warning": "Contengut sensible",
  "status.share": "Partejar",
  "status.show_less_all": "Los tornar plegar totes",
  "status.show_more_all": "Los desplegar totes",
  "status.show_original": "Veire l’original",
  "status.title.with_attachments": "{user} posted {attachmentCount, plural, one {an attachment} other {# attachments}}",
  "status.translate": "Traduire",
  "status.translated_from_with": "Traduch del {lang} amb {provider}",
  "status.uncached_media_warning": "Apercebut indisponible",
  "status.unmute_conversation": "Tornar mostrar la conversacion",
  "status.unpin": "Tirar del perfil",
  "subscribed_languages.lead": "Sonque las publicacions dins las lengas seleccionadas apreissaràn dins vòstre acuèlh e linha cronologica aprèp aqueste cambiament. Seleccionatz pas res per recebre las publicacions en quina lenga que siá.",
  "subscribed_languages.save": "Salvar los cambiaments",
  "subscribed_languages.target": "Lengas d’abonaments cambiadas per {target}",
  "tabs_bar.home": "Acuèlh",
  "tabs_bar.notifications": "Notificacions",
  "time_remaining.days": "demòra{number, plural, one  { # jorn} other {n # jorns}}",
  "time_remaining.hours": "demòra{number, plural, one { # ora} other {n # oras}}",
  "time_remaining.minutes": "demòra{number, plural, one { # minuta} other {n # minutas}}",
  "time_remaining.moments": "Moments restants",
  "time_remaining.seconds": "demòra{number, plural, one { # segonda} other {n # segondas}}",
  "trends.counter_by_accounts": "{count, plural, one {{counter} persona} other {{counter} personas}} dins los darrièrs {days, plural, one {jorn} other {{days} jorns}}",
  "trends.trending_now": "Tendéncia del moment",
  "ui.beforeunload": "Vòstre brolhon serà perdut se quitatz Mastodon.",
  "units.short.billion": "{count}Md",
  "units.short.million": "{count}M",
  "units.short.thousand": "{count}K",
  "upload_area.title": "Lisatz e depausatz per mandar",
  "upload_button.label": "Ajustar un mèdia (JPEG, PNG, GIF, WebM, MP4, MOV)",
  "upload_error.limit": "Talha maximum pels mandadís subrepassada.",
  "upload_error.poll": "Lo mandadís de fichièr es pas autorizat pels sondatges.",
  "upload_form.edit": "Modificar",
  "upload_progress.label": "Mandadís…",
  "upload_progress.processing": "Tractament…",
  "username.taken": "Aqueste nom d’utilizaire es pres. Ensajatz-ne un autre",
  "video.close": "Tampar la vidèo",
  "video.download": "Telecargar lo fichièr",
  "video.exit_fullscreen": "Sortir plen ecran",
  "video.expand": "Agrandir la vidèo",
  "video.fullscreen": "Ecran complèt",
  "video.hide": "Amagar la vidèo",
  "video.pause": "Pausa",
  "video.play": "Lectura",
  "visibility_modal.button_title": "Definir la visibilitat",
  "visibility_modal.header": "Visibilitat e interaccion",
  "visibility_modal.instructions": "Contrarotlatz qui pòt interagir amb aquesta publicacion. Podètz tanben aplicar de paramètres a totas las publicacions futuras en anant a <link>Preferéncias > Paramètres per defaut de publicacion</link>.",
  "visibility_modal.privacy_label": "Visibilitat",
  "visibility_modal.quote_followers": "Sonque pels seguidors",
  "visibility_modal.quote_label": "Qual pòt citar",
  "visibility_modal.quote_nobody": "Sonque ieu",
  "visibility_modal.quote_public": "Tot lo monde",
  "visibility_modal.save": "Enregistrar"
}
